import React from "react";
import menu from "../conf/menu";

const HelpComponent = ({location,employeeInfo,t}) => {
  document.title = t(menu[location.pathname])+" - masraf.dakika.com.tr";
    let yardimPdf =  employeeInfo.helpFile ? require('../assets/helpPdfs/'+ employeeInfo.helpFile) : null;
  return (
  <div className="content">
    <div className="container-fluid">
        <div className="row">
            <div className="col-xs-12">
                <div className="card">
                    <div className="header">
                        <h4 className="title">{t('help')}</h4>
                    </div>
                    <div className="content">
                        {
                            employeeInfo.helpFile ?
                                <p className="p">
                                    <span dangerouslySetInnerHTML={{__html: t('helpDownloadDescription', {yardimPdf})}}></span>
                                    <iframe width="100%" height="1000px" src={yardimPdf}></iframe>
                                </p> :
                                <p>{t('helpDocumentNotDefined')}</p>

                        }

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
)};

export default  HelpComponent
